// eslint-disable-next-line
/* eslint-disable */
import { getToken, setToken } from '../src/store/auth'
import store from './store'
import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import Login from './views/LoginLayout'
import Login from './views/LoginLocal.vue'
import LoginLocal from './views/LoginLocal.vue'
import HomeAdministrador from './views/HomeAdministrador'
import CadastrarRecepcionista from './components/administrador/recepcionistas/CadastrarRecepcionista'
import ListaRecepcionistas from './components/administrador/recepcionistas/ListaRecepcionistas'
import CadastrarServico from './components/administrador/servicos/CadastrarServico'
import ListaServico from './components/administrador/servicos/ListaServico'
import ListaAdministrador from './components/administrador/administrador/ListaAdministrador'
import CadastrarAdministrador from './components/administrador/administrador/CadastrarAdministrador'
import EditarSenhaAdministrador from './components/administrador/administrador/EditarSenhaAdministrador'
import EditarNomeAdministrador from './components/administrador/administrador/EditarNomeAdministrador'
import DashboardEmpresa from './components/administrador/DashboardEmpresa'

import HomeAdministradorDev from './views/HomeAdministradorDev'
import ListaVideos from './components/administradorDesenvolvimento/ListaVideos'
import CadastrarVideo from './components/administradorDesenvolvimento/CadastrarVideo'
import AlterarVideo from './components/administradorDesenvolvimento/AlterarVideo'
import Chat from './components/administradorDesenvolvimento/Chat'

import Help from './components/administradorDesenvolvimento/Help'
import CadastrarHelp from './components/administradorDesenvolvimento/CadastrarHelp'
import ListaTituloHelp from './components/administradorDesenvolvimento/ListaTituloHelp'
import CadastrarTituloHelp from './components/administradorDesenvolvimento/CadastrarTituloHelp'

import EditarDadosAdministradorUnidade from './components/administrador/administrador/EditarDadosAdministradorUnidade'

import EditarSenhaAdministradorUnidade from './components/administradorUnidade/administrador/EditarSenhaAdministradorUnidade'
import HelpAdministradorUnidade from './components/administradorUnidade/administrador/HelpAdministradorUnidade'
import EditarNomeAdministradorUnidade from './components/administradorUnidade/administrador/EditarNomeAdministradorUnidade'
import CoresUnidade from './components/administradorUnidade/administrador/CoresUnidade'

import ListaUnidade from './components/administrador/unidade/ListaUnidade'
import CadastrarUnidade from './components/administrador/unidade/CadastrarUnidade'
import EditarUnidade from './components/administrador/unidade/EditarUnidade'
import EditarNomeUnidadeEtiqueta from './components/administrador/unidade/EditarNomeUnidadeEtiqueta'

import HomeAdministradorUnidade from './views/HomeAdministradorUnidade2'
import DashboardUnidade from './components/administradorUnidade/DashboardUnidade2'
import FuncionariosOnline from './components/administradorUnidade/FuncionariosOnline'

import ListaAtendentesUnidade from './components/administradorUnidade/atendente/ListaAtendentesUnidade'
import CadastrarAtendenteUnidade from './components/administradorUnidade/atendente/CadastrarAtendenteUnidade'
import AlterarDadosAtendente from './components/administradorUnidade/atendente/AlterarDadosAtendente'

import ListaRecepcionistasUnidade from './components/administradorUnidade/recepcionista/ListaRecepcionistasUnidade'
import CadastrarRecepcionistaUnidade from './components/administradorUnidade/recepcionista/CadastrarRecepcionistaUnidade'
import AlterarDadosRecepcionista from './components/administradorUnidade/recepcionista/AlterarDadosRecepcionista'

import ListaPaineisUnidade from './components/administradorUnidade/painel/ListaPaineisUnidade'
import CadastrarPainelUnidade from './components/administradorUnidade/painel/CadastrarPainelUnidade'
import AlterarDadosPainel from './components/administradorUnidade/painel/AlterarDadosPainel'

import ListaLocaisUnidade from './components/administradorUnidade/local/ListaLocaisUnidade'
import CadastrarLocalUnidade from './components/administradorUnidade/local/CadastrarLocalUnidade'
import AlterarDadosLocal from './components/administradorUnidade/local/AlterarDadosLocal'

import Metricas from './components/administradorUnidade/metricas/Metricas'
import Graficos from './components/administradorUnidade/graficos/Graficos'

import CadastrarServicoUnidade from './components/administradorUnidade/servico/CadastrarServicoUnidade'
import AlterarDadosServico from './components/administradorUnidade/servico/AlterarDadosServico'
import ServicosUnidade from './components/administradorUnidade/servico/ServicosUnidade'
import AdicionarPeso from './components/administradorUnidade/servico/AdicionarPeso'

import MetricasMedico from './components/administradorUnidade/medico2/MetricasMedico2'
import ListaMedicosUnidade from './components/administradorUnidade/medico/ListaMedicosUnidade'
import CadastrarMedicoExame from './components/administradorUnidade/medico/CadastrarMedicoExame'
import CadastrarMedicoServico from './components/administradorUnidade/medico/CadastrarMedicoServico'
import CadastrarMedicoUnidade from './components/administradorUnidade/medico/CadastrarMedicoUnidade.vue'
import AlterarDadosMedico from './components/administradorUnidade/medico/AlterarDadosMedico.vue'

import ListaTecnicosUnidade from './components/administradorUnidade/tecnico/ListaTecnicosUnidade'
import CadastrarTecnicoExame from './components/administradorUnidade/tecnico/CadastrarTecnicoExame'
import CadastrarTecnicoServico from './components/administradorUnidade/tecnico/CadastrarTecnicoServico'
import AlterarDadosTecnico from './components/administradorUnidade/tecnico/AlterarDadosTecnico'

import ListaApoioUnidade from './components/administradorUnidade/apoio/ListaApoioUnidade'
import AlterarDadosApoio from './components/administradorUnidade/apoio/AlterarDadosApoio'
import CadastrarApoio from './components/administradorUnidade/apoio/CadastrarApoio'

import HomeRecepcionista from './views/HomeRecepcionista'
import HomeAtendente from './views/HomeAtendente'
import HomeMedico from './views/MedicoDashboard.vue'
import PosAtendimento from './views/PosAtendimento'
import HomeTecnico from './views/HomeTecnico'
import HomeApoio from './views/HomeApoio'
import HomeRecepcionistaEspecial from './views/HomeRecepcionistaEspecial'
import HomePainel from './views/HomePainel'

import PacienteInfoOs from './components/administradorUnidade/paciente/infoPaciente'
import InfoSenhas from './components/administradorUnidade/paciente/infoSenhas'
import anuncios from './components/administradorUnidade/anuncios/listarAnuncios'
import homeNutricionista from './views/HomeNutricionista.vue'

import Usuarios from './components/administradorUnidade/usuario/ListaUsuarios'
import CadastrarUsuario from './components/administradorUnidade/usuario/CadastrarUsuario'
import PerfilUsuario from './components/administradorUnidade/usuario/PerfilUsuario'

import DashVoucher from './components/posAtendimento/dashVoucher.vue'

Vue.use(Router)

const tipo = store.getters.usuario.tipo

// Guarda para rotas públicas (não requer autenticação)
const ifPublicRoute = (to, from, next) => {
  next()
}

const ifAuthenticated = (to, from, next) => {
  if (getToken()) {
    if (tipo == 1) {
      next('dashboardEmpresa')
      return
    }
    if (tipo == 5) {
      next('dashboardUnidade')
      return
    } else if (tipo == 4 || tipo == 8) {
      next('homeMedico')
      return
    } else if (tipo == 2) {
      next('homeRecepcionista')
      return
    } else if (tipo == 3) {
      next('homeAtendente')
      return
    } else if (tipo == 6) {
      next('homePainel')
      return
    } else if (tipo == 7) {
      next('homeApoio')
      return
    } else if (tipo == 8) {
      next('homeTecnico')
      return
    } else if (tipo == 10) {
      next('homeAdministradorDev')
      return
    } else if (tipo == 11) {
      next('homeRecepcionistaEspecial')
      return
    } else if (tipo == 12) {
      next('posAtendimento')
    } else if (tipo == 13) {
      next('homeNutricionista')
    }
  }
  next()
}

const ifNotAuthenticatedBackLogin = (to, from, next) => {
  if (getToken()) {
    next()
    return
  }
  next('/login')
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      beforeEnter: ifAuthenticated,
      component: Login,
    },
    
    // Rotas públicas
    {
      path: '/login',
      name: 'login',
      beforeEnter: ifPublicRoute,
      component: Login,
    },
    {
      path: '/loginLocal',
      name: 'loginLocal',
      beforeEnter: ifPublicRoute,
      component: LoginLocal,
    },

    {
      path: '/homeAdministradorDev',
      component: HomeAdministradorDev,
      children: [
        {
          path: '/listaVideos',
          name: 'listaVideos',
          component: ListaVideos,
        },
        {
          path: '/cadastrarVideo',
          name: 'cadastrarVideo',
          component: CadastrarVideo
        },
        {
          path: '/alterarVideo',
          name: 'alterarVideo',
          component: AlterarVideo
        },
        {
          path: '/chat',
          name: 'chat',
          component: Chat
        },
        {
          path: '/help',
          name: 'help',
          component: Help
        },
        {
          path: '/cadastrarHelp',
          name: 'cadastrarHelp',
          component: CadastrarHelp
        },
        {
          path: '/listaTituloHelp',
          name: 'listaTituloHelp',
          component: ListaTituloHelp
        },
        {
          path: '/cadastrarTituloHelp',
          name: 'cadastrarTituloHelp',
          component: CadastrarTituloHelp
        }
      ]
    },

    {
      path: '/homeAdministrador',
      component: HomeAdministrador,
      children: [
        {
          path: '/dashboardEmpresa',
          name: 'dashboardEmpresa',
          component: DashboardEmpresa,
          meta: { requiresAuth: true, identidade: 1 }
        },
        {
          path: '/listaRecepcionistas',
          name: 'listaRecepcionistas',
          component: ListaRecepcionistas,
        },
        {
          path: '/cadastrarRecepcionista',
          name: 'cadastrarRecepcionista',
          component: CadastrarRecepcionista,
        },
        {
          path: '/listaServico',
          name: 'listaServico',
          component: ListaServico,
        },
        {
          path: '/cadastrarServico',
          name: 'cadastrarServico',
          component: CadastrarServico,
        },
        {
          path: '/listaAdministrador',
          name: 'listaAdministrador',
          component: ListaAdministrador,
        },
        {
          path: '/cadastrarAdministrador',
          name: 'cadastrarAdministrador',
          component: CadastrarAdministrador,
        },
        {
          path: '/editarSenhaAdministrador',
          name: 'editarSenhaAdministrador',
          component: EditarSenhaAdministrador,
        },
        {
          path: '/editarNomeAdministrador',
          name: 'editarNomeAdministrador',
          component: EditarNomeAdministrador,
        },
        {
          path: '/editarDadosAdministradorUnidade',
          name: 'editarDadosAdministradorUnidade',
          component: EditarDadosAdministradorUnidade,
        },
        {
          path: '/listaUnidade',
          name: 'listaUnidade',
          component: ListaUnidade,
        },
        {
          path: '/cadastrarUnidade',
          name: 'cadastrarUnidade',
          component: CadastrarUnidade,
        },
        {
          path: '/editarUnidade',
          name: 'editarUnidade',
          component: EditarUnidade,
        },
        {
          path: '/editarNomeUnidadeEtiqueta',
          name: 'editarNomeUnidadeEtiqueta',
          component: EditarNomeUnidadeEtiqueta,
        },
      ],
    },

    {
      path: '/homeAdministradorUnidade',
      component: HomeAdministradorUnidade,
      children: [
        {
          path: '/dashboardUnidade',
          name: 'dashboardUnidade',
          component: DashboardUnidade,
        },
        {
          path: '/metricas',
          name: 'metricas',
          component: Metricas,
        },
        {
          path: '/funcionariosOnline',
          name: 'funcionariosOnline',
          component: FuncionariosOnline,
        },
        {
          path: '/editarNomeAdministradorUnidade',
          name: 'editarNomeAdministradorUnidade',
          component: EditarNomeAdministradorUnidade,
        },
        {
          path: '/editarSenhaAdministradorUnidade',
          name: 'editarSenhaAdministradorUnidade',
          component: EditarSenhaAdministradorUnidade,
        },
        {
          path: '/helpAdministradorUnidade',
          name: '/helpAdministradorUnidade',
          component: HelpAdministradorUnidade,
        },
        {
          path: '/coresUnidade',
          name: '/coresUnidade',
          component: CoresUnidade,
        },
        {
          path: '/listaAtendentesUnidade',
          name: 'listaAtendentesUnidade',
          component: ListaAtendentesUnidade,
        },
        {
          path: '/cadastrarAtendenteUnidade',
          name: 'cadastrarAtendenteUnidade',
          component: CadastrarAtendenteUnidade,
        },
        {
          path: '/alterarDadosAtendente',
          name: 'alterarDadosAtendente',
          component: AlterarDadosAtendente,
        },
        {
          path: '/listaRecepcionistasUnidade',
          name: 'listaRecepcionistasUnidade',
          component: ListaRecepcionistasUnidade,
        },
        {
          path: '/cadastrarRecepcionistaUnidade',
          name: 'cadastrarRecepcionistaUnidade',
          component: CadastrarRecepcionistaUnidade,
        },
        {
          path: '/alterarDadosRecepcionista',
          name: 'alterarDadosRecepcionista',
          component: AlterarDadosRecepcionista,
        },
        {
          path: '/listaPaineisUnidade',
          name: 'listaPaineisUnidade',
          component: ListaPaineisUnidade,
        },
        {
          path: '/cadastrarPainelUnidade',
          name: 'cadastrarPainelUnidade',
          component: CadastrarPainelUnidade,
        },
        {
          path: '/alterarDadosPainel',
          name: 'alterarDadosPainel',
          component: AlterarDadosPainel,
        },
        {
          path: '/listaLocaisUnidade',
          name: 'listaLociasUnidade',
          component: ListaLocaisUnidade,
        },
        {
          path: '/cadastrarLocalUnidade',
          name: 'cadastrarLocalUnidade',
          component: CadastrarLocalUnidade,
        },
        {
          path: '/alterarDadosLocal',
          name: 'alterarDadosLocal',
          component: AlterarDadosLocal,
        },
        {
          path: '/adicionarPeso',
          name: 'adicionarPeso',
          component: AdicionarPeso,
        },
        {
          path: '/servicosUnidade',
          name: 'servicosUnidade',
          component: ServicosUnidade,
        },
        {
          path: '/pacienteInfoOs',
          name: 'pacienteInfoOs',
          component: PacienteInfoOs,
        },
        {
          path: '/infoSenhas',
          name: 'infoSenhas',
          component: InfoSenhas,
        },
        {
          path: '/anuncios',
          name: 'anuncios',
          component: anuncios,
        },
        {
          path: '/cadastrarServicoUnidade',
          name: 'cadastrarServicoUnidade',
          component: CadastrarServicoUnidade,
        },
        {
          path: '/alterarDadosServico',
          name: 'alterarDadosServico',
          component: AlterarDadosServico,
        },
        {
          path: '/metricasMedico',
          name: 'metricaMedicos',
          component: ListaMedicosUnidade,   
        },
        {
          path: '/listaMedicosUnidade',
          name: 'listaMedicosUnidade',
          component: ListaMedicosUnidade,
        },
        {
          path: '/cadastrarMedicoExame',
          name: 'cadastrarMedicoExame',
          component: CadastrarMedicoExame,
        },
        {
          path: '/cadastrarMedicoServico',
          name: 'cadastrarMedicoServico',
          component: CadastrarMedicoServico,
        },
        {
          path: '/cadastrarMedicoUnidade',
          name: 'cadastrarMedicoUnidade',
          component: CadastrarMedicoUnidade,
        },
        {
          path: '/alterarDadosMedico',
          name: 'alterarDadosMedico',
          component: AlterarDadosMedico,
        },
        {
          path: '/listaTecnicosUnidade',
          name: 'listaTecnicosUnidade',
          component: ListaTecnicosUnidade,
        },
        {
          path: '/cadastrarTecnicoExame',
          name: 'cadastrarTecnicoExame',
          component: CadastrarTecnicoExame,
        },
        {
          path: '/cadastrarTecnicoServico',
          name: 'cadastrarTecnicoServico',
          component: CadastrarTecnicoServico,
        },
        {
          path: '/alterarDadosTecnico',
          name: 'alterarDadosTecnico',
          component: AlterarDadosTecnico,
        },
        {
          path: '/listaApoioUnidade',
          name: 'listaApoioUnidade',
          component: ListaApoioUnidade,
        },
        {
          path: '/cadastrarApoioUnidade',
          name: 'cadastrarApoioUnidade',
          component: CadastrarApoio,
        },
        {
          path: '/alterarDadosApoio',
          name: 'alterarDadosApoio',
          component: AlterarDadosApoio,
        },
        {
          path: '/graficos',
          name: 'graficos',
          component: Graficos,
        },
        {
          path: '/usuarios',
          name: 'usuarios',
          component: Usuarios,
        },
        {
          path: '/cadastrarUsuario',
          name: 'cadastrarUsuario',
          component: CadastrarUsuario,
          props: true
        },
        {
          path: '/perfilUsuario',
          name: 'perfilUsuario',
          component: PerfilUsuario,
          props: true
        },
        {
          path: '/dashVoucher',
          name: 'dashVoucher',
          component: DashVoucher
        }
      ]
    },

    {
      path: '/homeMedico',
      name: 'homeMedico',
      beforeEnter: ifNotAuthenticatedBackLogin,
      component: HomeMedico,
      meta: { requiresAuth: true, identidade: 4 }
    },
    {
      path: '/homeNutricionista',
      name: 'homeNutricionista',
      component: homeNutricionista,
      beforeEnter: ifNotAuthenticatedBackLogin,
      meta: { requiresAuth: true, identidade: 13 }
    },
    {
      path: '/posAtendimento',
      name: 'posAtendimento',
      beforeEnter: ifNotAuthenticatedBackLogin,
      component: PosAtendimento,
      meta: { requiresAuth: true, identidade: 12 }
    },
    {
      path: '/homeTecnico',
      name: 'homeTecnico',
      beforeEnter: ifNotAuthenticatedBackLogin,
      component: HomeTecnico,
      meta: { requiresAuth: true, identidade: 8 }
    },
    {
      path: '/homeRecepcionista',
      name: 'homeRecepcionista',
      beforeEnter: ifNotAuthenticatedBackLogin,
      component: HomeRecepcionista,
      meta: { requiresAuth: true, identidade: 3 }
    },
    {
      path: '/homeApoio',
      name: 'homeApoio',
      beforeEnter: ifNotAuthenticatedBackLogin,
      component: HomeApoio,
      meta: { requiresAuth: true, identidade: 7 }
    },
    {
      path: '/homeRecepcionistaEspecial',
      name: 'homeRecepcionistaEspecial',
      beforeEnter: ifNotAuthenticatedBackLogin,
      component: HomeRecepcionistaEspecial,
      meta: { requiresAuth: true, identidade: 11 }
    },
    {
      path: '/homeAtendente',
      beforeEnter: ifNotAuthenticatedBackLogin,
      name: 'homeAtendente',
      component: HomeAtendente,
      meta: { requiresAuth: true, identidade: 2 },
    },
    {
      path: '/homePainel',
      name: 'homePainel',
      beforeEnter: ifNotAuthenticatedBackLogin,
      component: HomePainel,
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

export default router